import * as React from "react"

import { cn } from "@/lib/utils"

function Input({
    className,
    type,
    ...props
}: React.ComponentProps<"input">) {
    return (
        <input
            type={type}
            data-slot="input"
            className={cn(
                "file:text-foreground placeholder:text-slate-400 placeholder:font-light selection:bg-primary selection:text-primary-foreground border-input h-9 w-full min-w-0 rounded-md border bg-slate-50 px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-slate-100 disabled:text-slate-500 disabled:border-slate-200 disabled:opacity-100 md:text-sm read-only:bg-slate-100 read-only:text-slate-500 read-only:border-slate-200 read-only:cursor-default",
                "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
                "aria-invalid:ring-2 aria-invalid:ring-destructive/25 aria-invalid:border-destructive aria-invalid:bg-red-50/40 aria-invalid:text-destructive aria-invalid:font-bold aria-invalid:placeholder:text-destructive/80 aria-invalid:placeholder:font-bold",
                className
            )}
            {...props} />
    );
}

export { Input }
